<template>
        <!-- Google Tag Manager (noscript) -->
        <noscript>
                <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PPMDMRC" height="0" width="0"
                        style="display:none;visibility:hidden">
                </iframe>
        </noscript>
        <!-- End Google Tag Manager (noscript) -->
</template>
